import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { SocioEmotionalSkillTestResult } from '../socio-emotional-skills-test-results.models';
import { SocioEmotionalSkill } from '../../socio-emotional-skills-test/socio-emotional-skills-test.models';
import { getLevel } from '../utils/socio-emotional-skills-test-results.utils';

@Component({
  selector: 'app-socio-emotional-skills-test-results-history-chart',
  templateUrl: './socio-emotional-skills-test-results-history-chart.component.html',
  styleUrls: ['./socio-emotional-skills-test-results-history-chart.component.scss']
})
export class SocioEmotionalSkillsTestResultsHistoryChartComponent implements OnChanges {
  @Input() skills: SocioEmotionalSkill[] = [];
  @Input() lastThreeResults: SocioEmotionalSkillTestResult[] = [];

  skillCharts: { skill: SocioEmotionalSkill; chartOptions: any; levelDescription: string }[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.skills || changes.lastThreeResults) {
      this.buildCharts();
    }
  }

  private buildCharts(): void {
    this.skillCharts = [];

    const sortedResults = [...this.lastThreeResults].sort((a, b) =>
      new Date(a.submittedAt).getTime() - new Date(b.submittedAt).getTime()
    );

    this.skills.forEach(skill => {
      const data: number[] = [];
      const labels: string[] = [];
      const colors: string[] = [];
      let levelDescription = '';

      sortedResults.forEach(result => {
        const skillScore = result.skillScores.find(s => s.skill._id === skill._id);
        const score = skillScore?.average ?? 0.1;
        const level = getLevel(skill, score);
        const color = level.color ?? '#ccc';

        data.push(score);
        labels.push(result.semesterName || new Date(result.submittedAt).toLocaleDateString('es-CO', { month: 'short', day: 'numeric' }));
        colors.push(color);

          if (result === sortedResults[sortedResults.length - 1]) {
          levelDescription = level.description ?? '';
        }
      });

      console.log('Skill:', skill.name, 'Data:', data, 'Labels:', labels, 'Colors:', colors);

      this.skillCharts.push({
        skill,
        levelDescription,
        chartOptions: {
          series: [{ name: 'Nivel (%)', data }],
          chart: {
            type: 'bar',
            height: 350,
            width: 400,
          },
          xaxis: {
            categories: labels,
            labels: {
              style: {
                fontSize: '12px',
                fontFamily: 'Poppins, sans-serif',
              },
              rotate: -45,
              rotateAlways: true,
              hideOverlappingLabels: false,
            },
          },
          yaxis: {
            min: 0,
            max: 100
          },
          plotOptions: {
            bar: {
              distributed: true,
              columnWidth: '40%'
            }
          },
          colors,
          dataLabels: {
            enabled: false
          },
          tooltip: {
            enabled: true
          }
        }
      });
    });
  }
}
